export default (name: string) => /[a-zA-Z가-힣]/.test(name);
